export default {"src":"/_next/static/media/EHAQA-booking.f54821b6.svg","height":24,"width":138};